import {Observable} from "rxjs";
import '../../configs/Event_config.ts';

export function EventConfigProvider() {
  return new Observable<any>(observer => {
    observer.next(window['eventConfig']);
  });
}

